import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { useLanguagesQuery } from 'modules/_common/hooks';
import { ITemplateProps } from 'modules/_common/models';
import { getMailTaskGuestRenterMails } from 'modules/accommodations/features/reservations/api';

export const useQueryMailTaskGuestRenterMails = ({ calculationId }: { calculationId: string }) => {
  return useQuery(QUERY_KEYS.RENTALS_CALCULATION_TEMPLATE_EMAILS, () =>
    getMailTaskGuestRenterMails({ calculationId }),
  );
};
